import React from 'react';
import styled from 'styled-components';

const Button = styled.button`
  width: 70px;
  height: 50px;
  border: none;
  margin: 10px;
  cursor: pointer;
  font-size: 15px;
  font-weight: bold;
  position: relative;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: inset 0 0 0 3px #218921;

  span {
    position: relative;
    z-index: 2;
  }

  &::after {
    position: absolute;
    content: '';
    width: 250px;
    height: 250px;
    background-color: rgba(255, 255, 255, 0.9);
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%) scale(1) rotate(45deg);
    transform-origin: 50%;
    transition: transform 0.5s cubic-bezier(0.61, 0.07, 0.23, 0.89);
    z-index: 1;
  }

  &:hover::after {
    transform: translate(-50%, -50%) scale(0) rotate(45deg);
  }
`;

const SendButton = ({ type = 'submit', value }) => (
  <Button type={type}>
    <span>{value}</span>
  </Button>
);

export default SendButton;
